import React from 'react'

import SuccessIcon from 'Assets/Images/icons/success'
import { StyledWrapper, StyledTitle, StyledContent } from './styles'

const UploadSuccess = () => (
  <StyledWrapper>
    <SuccessIcon />
    <StyledTitle>Success</StyledTitle>
    <StyledContent>The report has been successfully uploaded.</StyledContent>
    <StyledContent>
      <b>Please note:</b> After uploading, system checks are performed to ensure
      accuracy. It may take approximately 2 hours for the conversion data and
      any associated bonuses (if applicable) to be fully processed and reflected
      in the Brand Ambassador App.
    </StyledContent>
  </StyledWrapper>
)

export default UploadSuccess
